import { Typography } from "@mui/material";
import "./style.scss";
import { AOSContainer, AOSWrapper } from "../../../../common/AOSContainer";
const CitiisValues = (props) => {
  return (
    <div className={props.backgroundInverse ? "whowearesection1maindivinverse" : "whowearesection1maindiv"}>
      <div className='ourValuesHeading' >
        <AOSContainer animationType="fade-right">
          <Typography variant="thinmedium" style={{ color: "#525151" }}>
            Our values
          </Typography>
          {/* <Typography variant="thicklarge" style={{ color: "#525151" }}>
            values
          </Typography> */}
        </AOSContainer>
      </div>
      <div className="row secondcompdiv">

        {/* <AOSWrapper animationType="fade-up"> */}
        <div className="textwowearesec1mobile">

        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          className="citiisvaluegraphictextcontentmobile"
        >
          <div className="col-md-12 graphichowdoes">
            {/* <div className="col-md-6 textwowearesec1">
              <AOSContainer animationType="fade-right">
                <Typography variant="thinmedium" style={{ color: "#525151" }}>
                  Our{" "}
                </Typography>
                <Typography variant="thicklarge" style={{ color: "#525151" }}>
                  values
                </Typography>
              </AOSContainer>
            </div> */}

            <div className="col-md-6 text2wowearesec1 wearesecdesk">
              <AOSContainer animationType="fade-right">
                <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
                  The projects are designed
                </Typography>
                <Typography variant="thinsmall">
                  to make use of technology for
                </Typography>
                <Typography variant="thicksmall">
                  creating innovative
                </Typography>
                <Typography variant="thicksmall">
                  processes or assets.
                </Typography>
              </AOSContainer>
            </div>
            <div className="col-md-6 text2wowearesec1 wearesecmobile">
              <AOSContainer animationType="fade-right">
                <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
                  The projects are designed
                </Typography>
                <Typography variant="thinsmall">
                  to make use of technology for
                </Typography>
                <Typography variant="thicksmall">
                  creating innovative
                </Typography>
                <Typography variant="thicksmall">
                  processes or assets.
                </Typography>
              </AOSContainer>
            </div>

            <div className="col-md-6 text2wowearesec12 newalignsec1 text2wowearesec12desk">
              <AOSWrapper animationType="fade-left">
                <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
                  The projects value
                </Typography>
                <Typography variant="thinsmall">and demonstrate</Typography>
                <Typography variant="thicksmall">
                  cooperation between
                </Typography>
                <Typography variant="thicksmall">stakeholders and</Typography>
                <Typography variant="thinsmall">
                  address the needs of
                </Typography>
                <Typography variant="thinsmall">beneficiaries.</Typography>
              </AOSWrapper>
            </div>
            <div className="col-md-6 text2wowearesec12 newalignsec1 text2wowearesec12mobile">
              <AOSContainer animationType="fade-left">
                <Typography variant="thinsmall" sx={{ marginTop: "20px" }}>
                  The projects value
                </Typography>
                <Typography variant="thinsmall">and demonstrate</Typography>
                <Typography variant="thicksmall">
                  cooperation between
                </Typography>
                <Typography variant="thicksmall">stakeholders and</Typography>
                <Typography variant="thinsmall">
                  address the needs of
                </Typography>
                <Typography variant="thinsmall">beneficiaries.</Typography>
              </AOSContainer>
            </div>
            <div className="col-md-6 texttowowearesectwo wearsectwodesk">
              <AOSContainer animationType="fade-right">
                <Typography variant="thinsmall">The projects are</Typography>
                <Typography variant="thicksmall">
                  appropriate, viable and
                </Typography>
                <Typography variant="thicksmall">
                  achievable,{" "}
                  <Typography variant="thinsmall" component="span">
                    in line with
                  </Typography>
                </Typography>
                <Typography variant="thinsmall">
                  local constraints, strengths
                </Typography>
                <Typography variant="thinsmall">and opportunities.</Typography>
              </AOSContainer>
            </div>
            <div className="col-md-6 texttowowearesectwo wearsectwomobile">
              <AOSContainer animationType="fade-right">
                <Typography variant="thinsmall">The projects are</Typography>
                <Typography variant="thicksmall">
                  appropriate, viable and
                </Typography>
                <Typography variant="thicksmall">
                  achievable,{" "}
                  <Typography variant="thinsmall" component="span">
                    in line with
                  </Typography>
                </Typography>
                <Typography variant="thinsmall">
                  local constraints, strengths
                </Typography>
                <Typography variant="thinsmall">and opportunities.</Typography>
              </AOSContainer>
            </div>
            <div className="col-md-6 texttowowearesectworight wearsectworightdesk">
              <AOSContainer animationType="fade-left">
                <Typography variant="thinsmall">
                  The projects include
                </Typography>
                <Typography variant="thinsmall">
                  actions that contribute to
                </Typography>
                <Typography variant="thicksmall">social inclusion,</Typography>
                <Typography variant="thicksmall">
                  environmental resilience,
                </Typography>
                <Typography variant="thicksmall">
                  and project sustainability.
                </Typography>
              </AOSContainer>
            </div>
            <div className="col-md-6 texttowowearesectworight wearsectworightmobile">
              <AOSContainer animationType="fade-left">
                <Typography variant="thinsmall">
                  The projects include
                </Typography>
                <Typography variant="thinsmall">
                  actions that contribute to
                </Typography>
                <Typography variant="thicksmall">social inclusion,</Typography>
                <Typography variant="thicksmall">
                  environmental resilience,
                </Typography>
                <Typography variant="thicksmall">
                  and project sustainability.
                </Typography>
              </AOSContainer>
            </div>
          </div>
        </div>
        {/* </AOSWrapper> */}
      </div>
    </div>
  );
};

export default CitiisValues;
